module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUCB1j+P//PyMACP0C/5dloDwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/image/dot.png
// module id = t78M
// module chunks = 1